@if (analyticsLoading) {
  <div class="d-flex loading-wrapper">
    <ix-spinner size="large"></ix-spinner>
  </div>
}

@if (!analyticsLoading && !analyticsEmpty) {
  <div class="h-100 w-100 dashboard-grid">
    <div class="c2-r2 dashboard-card position-relative">
      <ix-typography [bold]="true" format="body-lg" id="dashboardCard1Headline">
        {{ 'overview.tabs.overview_tab.card_chart' | translate }}
      </ix-typography>
      <div
        class="all-passes-centered position-absolute text-center fw-bold top-50"
        id="dashboardCard1Sum">
        {{
        'overview.tabs.overview_tab.passes_plural'
        | translate
        : {
        number_of_passports:
        analytics.statistics.totalPassports || 0,
      }
      }}
    </div>
    <div
      [options]="pieChart"
      [theme]="getChartTheme()"
      (chartClick)="onPieChartClick($event)"
      echarts
      id="dashboardCard1Chart"
    ></div>
  </div>
  <div class="c1-r1 dashboard-card flex-column">
    <div
      class="h-100 d-flex flex-column justify-content-between align-content-between">
      <ix-typography [bold]="true" format="body-lg"
        id="dashboardCard2Headline"
        >{{ 'overview.tabs.overview_tab.card_done' | translate }}
      </ix-typography>
      @if (analytics.statistics) {
        <ix-typography
          class="align-self-end"
          format="display-xl"
          id="dashboardCard2Value"
          >{{
          (analytics.statistics.passportsInCompletedState * 100) /
          (analytics.statistics.passportsInCompletedState +
          analytics.statistics.passportsInDraftState) | number: '1.0-0'
          }}
          %
        </ix-typography>
      }
    </div>
  </div>
  <div class="c1-r1 dashboard-card flex-column">
    <div
      class="h-100 d-flex flex-column justify-content-between align-content-between"
      >
      <ix-typography [bold]="true" format="body-lg"
        id="dashboardCard3Headline"
        >{{ 'overview.tabs.overview_tab.card_renewable_share' | translate }}
      </ix-typography>
      <div
        [options]="barChart"
        [theme]="getChartTheme()"
        echarts
        id="dashboardCard3Chart"
      ></div>
    </div>
  </div>
  <div class="c2-r1 dashboard-card">
    <div
      class="h-100 d-flex flex-column justify-content-between align-content-between"
      >
      <ix-typography [bold]="true" format="body-lg"
        id="dashboardCard4Headline"
        >{{ 'overview.tabs.overview_tab.card_emission_total' | translate }}
      </ix-typography>
      @if (
        analytics.statistics &&
        analytics.statistics.averageCarbonFootprintPerWeek?.weeks?.length &&
        analytics.statistics.averageCarbonFootprintPerWeek?.values?.length) {
        <div
          [options]="lineChart"
          [theme]="getChartTheme()"
          echarts
          id="dashboardCard4Chart"
        ></div>
      } @else {
        <ix-empty-state
          layout="compact"
            header="{{
              'overview.tabs.overview_tab.carbon_footprint_no_data_header'
                | translate
            }}"
        ></ix-empty-state>
      }
    </div>
  </div>
</div>
}

@if (!analyticsLoading && analyticsEmpty) {
  <ix-row>
    <ix-col
      class="d-flex flex-column align-items-center justify-content-center"
      >
      <ix-empty-state
        (actionClick)="addNewPassportClick()"
        action="{{ 'battery_pass.create.workflow' | translate }}"
        class="no-battery-pass"
        header="{{ 'battery_pass.list.no_passport_available' | translate }}"
        icon="add"
        subHeader="{{ 'battery_pass.list.add_passport_first' | translate }}"
        >
      </ix-empty-state>
    </ix-col>
  </ix-row>
}
